import { render } from "./ShopCart.vue?vue&type=template&id=d25024d4"
import script from "./ShopCart.vue?vue&type=script&lang=js"
export * from "./ShopCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__